import { createContext } from 'react';

export const videosContext = createContext({});
